// 3. Updated Navbar.js with Redux
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import './navbar.scss';
import Dropdown from 'react-bootstrap/Dropdown';
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useWalletAuth } from "./hooks/useWalletAuth";
import { useProfile } from "../../../hooks/useProfile";
import Loader from "../../../shared/Loader";
import WalletDropdown from "./components/WalletDropdown";
import ProfileDropdown from "./components/ProfileDropdown";
import EditProfileModal from "./components/EditProfileModal";
import {
  openEditProfileModal,
  closeEditProfileModal,
  closeSuccessModal,
  handleEditProfileSuccess
} from '../../../Redux/store/modalSlice';
import { useChainId } from "wagmi";
import { useTheme } from "../../../hooks/ThemeProvider";
import { useChainSwitch } from "../../../hooks/useChainSwitch";
import useWallet from "../../../hooks/useWallet";
import { mainnet } from "viem/chains";

const Navbar = () => {
  // const { theme } = useTheme();
  // const { switchToChain } = useChainSwitch();
  const { theme, toggle } = useTheme();
  const dispatch = useDispatch();
  const { showEditProfileModal, showSuccessModal } = useSelector(state => state.modal);
  const chainId = useChainId();
  // console.log(chainId == mainnet.id, mainnet.id, 'chainIdchainIdchainId');
  
  // const { address } = useWallet();
  // console.log(chainId, 'chainId');
  const {
    isConnected,
    isSigningInProgress,
    isSignPending,
    isMobile,
    connectors,
    logedIn,
    handleWalletConnect,
    handleWalletDisconnect
  } = useWalletAuth();
  // console.log(isConnected, 'isConnected')
  const handleWalletDisconnectWithReset = () => {
    handleWalletDisconnect();
    resetProfile();
  };
  const {
    userProfile,
    isLoadingProfile,
    fetchUserProfile,
    resetProfile
  } = useProfile(logedIn, handleWalletDisconnectWithReset);

  // // Fetch profile when connected
  // useEffect(() => {
  //   const token = localStorage.getItem('accessToken');
  //   if (token && isConnected) {
  //     fetchUserProfile();
  //   }
  // }, [isConnected]);

  const handleEditProfile = () => {
    dispatch(openEditProfileModal());
  };

  const handleEditProfileSuccessAction = () => {
    dispatch(handleEditProfileSuccess());
    fetchUserProfile(); // Refresh profile data
  };



  const handleCloseSuccessModal = () => {
    dispatch(closeSuccessModal());
  };

  const handleCloseEditModal = () => {
    dispatch(closeEditProfileModal());
  };
  // useEffect(() => {
  //   if (address  && chainId !== mainnet.id) {
  //     switchToChain();
  //   }
   
  // }
  //   , [address, chainId]);

  return (
    <>
      {/* {(isSigningInProgress || isLoadingProfile) && ( */}
      {(isSigningInProgress) && (
        <Loader
          loadingText={
            isSigningInProgress
              ? (isSignPending
                ? 'Please sign the message in your wallet...'
                : 'Authenticating...')
              : 'Loading profile...'
          }
        />
      )}

      <section className='main_navbar'>
        <div className="custom-container">
          <div className="inner_navbbar">
            <Link to="/">
              {
                theme === 'dark' ? <img src="\assets\logo.svg" alt="Logo" /> :
                  <> <img src="\assets\whitelog.svg" alt="Logo" /> </> 
              }

            </Link>

            <div className="create_main">
              <div>
                <div className="toggle-container">
                  <input
                    type="checkbox"
                    id="theme-toggle"
                    className="theme-toggle"
                    checked={theme === 'dark'}
                    onChange={toggle}

                  />
                  <label htmlFor="theme-toggle" className="toggle-label">

                    {
                      theme === 'dark' ? <span className="moon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <mask id="path-1-inside-1_894_36" fill="white">
                            <path d="M4.75879 0.74408C4.72272 0.829872 4.68919 0.917254 4.65723 1.0058C3.65299 3.78824 5.09451 6.85801 7.87695 7.86224C8.97029 8.25676 10.1072 8.27117 11.1465 7.97748C10.0494 10.5879 7.0866 11.9088 4.39258 10.9365C1.61037 9.93213 0.168723 6.86233 1.17285 4.08002C1.78237 2.39122 3.15355 1.1979 4.75879 0.74408Z" />
                          </mask>
                          <path d="M4.75879 0.74408L6.00735 1.26898L7.09772 -1.32465L4.39033 -0.559243L4.75879 0.74408ZM4.65723 1.0058L3.38327 0.545962L3.38326 0.546L4.65723 1.0058ZM7.87695 7.86224L7.41715 9.13621L7.41725 9.13625L7.87695 7.86224ZM11.1465 7.97748L12.3951 8.50225L13.4849 5.9092L10.7782 6.67412L11.1465 7.97748ZM4.39258 10.9365L3.9327 12.2104L3.93278 12.2104L4.39258 10.9365ZM1.17285 4.08002L-0.101118 3.62022L-0.101127 3.62024L1.17285 4.08002ZM4.75879 0.74408L3.51023 0.21918C3.46319 0.331066 3.42123 0.44081 3.38327 0.545962L4.65723 1.0058L5.93118 1.46563C5.95715 1.3937 5.98225 1.32868 6.00735 1.26898L4.75879 0.74408ZM4.65723 1.0058L3.38326 0.546C2.12509 4.03202 3.93111 7.87804 7.41715 9.13621L7.87695 7.86224L8.33675 6.58827C6.25792 5.83799 5.1809 3.54446 5.9312 1.4656L4.65723 1.0058ZM7.87695 7.86224L7.41725 9.13625C8.78741 9.63065 10.2143 9.64835 11.5148 9.28084L11.1465 7.97748L10.7782 6.67412C10.0001 6.894 9.15318 6.88287 8.33666 6.58824L7.87695 7.86224ZM11.1465 7.97748L9.89787 7.4527C9.07851 9.40224 6.8645 10.3887 4.85238 9.66249L4.39258 10.9365L3.93278 12.2104C7.30869 13.4289 11.0202 11.7736 12.3951 8.50225L11.1465 7.97748ZM4.39258 10.9365L4.85245 9.66252C2.77372 8.91213 1.69664 6.61849 2.44683 4.53979L1.17285 4.08002L-0.101127 3.62024C-1.35919 7.10617 0.447013 10.9521 3.9327 12.2104L4.39258 10.9365ZM1.17285 4.08002L2.44682 4.53982C2.90152 3.27996 3.92314 2.38781 5.12725 2.0474L4.75879 0.74408L4.39033 -0.559243C2.38395 0.00797826 0.663211 1.50248 -0.101118 3.62022L1.17285 4.08002Z" fill="white" mask="url(#path-1-inside-1_894_36)" />
                        </svg>

                      </span>
                        : <span className="moon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <mask id="path-1-inside-1_830_45254" fill="white">
                              <path d="M4.75879 0.744019C4.72272 0.829811 4.68919 0.917193 4.65723 1.00574C3.65299 3.78818 5.09451 6.85795 7.87695 7.86218C8.97029 8.2567 10.1072 8.27111 11.1465 7.97742C10.0494 10.5878 7.0866 11.9087 4.39258 10.9364C1.61037 9.93207 0.168723 6.86227 1.17285 4.07996C1.78237 2.39116 3.15355 1.19784 4.75879 0.744019Z" />
                            </mask>
                            <path d="M4.75879 0.744019L6.00735 1.26892L7.09772 -1.32471L4.39033 -0.559304L4.75879 0.744019ZM4.65723 1.00574L3.38327 0.545901L3.38326 0.545939L4.65723 1.00574ZM7.87695 7.86218L7.41715 9.13615L7.41725 9.13619L7.87695 7.86218ZM11.1465 7.97742L12.3951 8.50219L13.4849 5.90914L10.7782 6.67406L11.1465 7.97742ZM4.39258 10.9364L3.9327 12.2103L3.93278 12.2104L4.39258 10.9364ZM1.17285 4.07996L-0.101118 3.62016L-0.101127 3.62018L1.17285 4.07996ZM4.75879 0.744019L3.51023 0.219119C3.46319 0.331005 3.42123 0.440749 3.38327 0.545901L4.65723 1.00574L5.93118 1.46557C5.95715 1.39364 5.98225 1.32862 6.00735 1.26892L4.75879 0.744019ZM4.65723 1.00574L3.38326 0.545939C2.12509 4.03196 3.93111 7.87797 7.41715 9.13615L7.87695 7.86218L8.33675 6.58821C6.25792 5.83792 5.1809 3.5444 5.9312 1.46554L4.65723 1.00574ZM7.87695 7.86218L7.41725 9.13619C8.78741 9.63058 10.2143 9.64829 11.5148 9.28078L11.1465 7.97742L10.7782 6.67406C10.0001 6.89394 9.15318 6.88281 8.33666 6.58818L7.87695 7.86218ZM11.1465 7.97742L9.89787 7.45264C9.07851 9.40218 6.8645 10.3886 4.85238 9.66243L4.39258 10.9364L3.93278 12.2104C7.30869 13.4288 11.0202 11.7735 12.3951 8.50219L11.1465 7.97742ZM4.39258 10.9364L4.85245 9.66246C2.77372 8.91207 1.69664 6.61843 2.44683 4.53973L1.17285 4.07996L-0.101127 3.62018C-1.35919 7.10611 0.447013 10.9521 3.9327 12.2103L4.39258 10.9364ZM1.17285 4.07996L2.44682 4.53975C2.90152 3.2799 3.92314 2.38775 5.12725 2.04734L4.75879 0.744019L4.39033 -0.559304C2.38395 0.00791723 0.663211 1.50242 -0.101118 3.62016L1.17285 4.07996Z" fill="#D1DBDF" mask="url(#path-1-inside-1_830_45254)" />
                          </svg>
                        </span>
                    }








                    <span className="sun">

                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <circle cx="5.91193" cy="6.01862" r="2.06791" stroke="#D1DBDF" stroke-width="1.43218" />
                        <path d="M6.82129 10.136L6.84222 11.8167L5.17835 11.8374L5.15742 10.1567L6.82129 10.136Z" fill="#D1DBDF" />
                        <path d="M6.82129 0.162598L6.84222 1.84332L5.17835 1.86405L5.15742 0.183323L6.82129 0.162598Z" fill="#D1DBDF" />
                        <path d="M1.86377 6.82141L0.183045 6.84235L0.16232 5.17848L1.84304 5.15754L1.86377 6.82141Z" fill="#D1DBDF" />
                        <path d="M11.8379 6.82141L10.1572 6.84235L10.1364 5.17848L11.8172 5.15754L11.8379 6.82141Z" fill="#D1DBDF" />
                        <path d="M2.49512 3.65649L1.29186 2.48285L2.45374 1.29166L3.657 2.4653L2.49512 3.65649Z" fill="#D1DBDF" />
                        <path d="M9.54688 10.7084L8.34362 9.53473L9.5055 8.34354L10.7088 9.51718L9.54688 10.7084Z" fill="#D1DBDF" />
                        <path d="M8.34375 2.49457L9.5174 1.29131L10.7086 2.45319L9.53494 3.65645L8.34375 2.49457Z" fill="#D1DBDF" />
                        <path d="M1.29248 9.54669L2.46613 8.34344L3.65732 9.50532L2.48367 10.7086L1.29248 9.54669Z" fill="#D1DBDF" />
                      </svg>


                    </span>
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>
              {isConnected && (
                <div className="create_button">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      Create <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                        <path d="M1 1.5L4 4.5L7 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="innner_side">
                        <Dropdown.Item className="inner_Drop" as="div">
                          <Link to="/createpool">
                            <div className="inner_more">
                              <img src="\assets\root.svg" alt="Root" />
                              <h5>Create Root Pool</h5>
                            </div>
                          </Link>
                        </Dropdown.Item>

                        <Dropdown.Item className="inner_Drop" as="div">
                          <Link to="/childpool">
                            <div className="inner_more">
                              <img src="\assets\child.svg" alt="Child" />
                              <h5>Create Child Pool</h5>
                            </div>
                          </Link>
                        </Dropdown.Item>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}

              {isConnected && (
                <ProfileDropdown

                  userProfile={userProfile}
                  onEditProfile={handleEditProfile}
                  onDisconnectWallet={handleWalletDisconnectWithReset}
                />
              )}

              <div className="connect_button">
                <WalletDropdown
                  isConnected={isConnected}
                  isSigningInProgress={isSigningInProgress}
                  isSignPending={isSignPending}
                  isMobile={isMobile}
                  connectors={connectors}
                  onWalletConnect={handleWalletConnect}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Edit Profile Modal */}
      <EditProfileModal
        show={showEditProfileModal}
        onHide={handleCloseEditModal}
        onSuccess={handleEditProfileSuccessAction}
        userProfile={userProfile}
        handleWalletDisconnectWithReset={handleWalletDisconnectWithReset}
      />

      {/* Success Modal */}
      <Modal
        className="stakingmodal"
        show={showSuccessModal}
        onHide={handleCloseSuccessModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="succes_modal">
            <div className="top_success">
              <img src="\assets\tick.svg" alt="Success" />
              <h3>Profile Updated</h3>
              <p>Your changes have been saved successfully.</p>
            </div>

            <div className="buton_modal_div">
              <button onClick={handleCloseSuccessModal}>Close</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;